'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axiosInterceptorsLoader = require('./axios-interceptors-loader');

var _axiosInterceptorsLoader2 = _interopRequireDefault(_axiosInterceptorsLoader);

var _axiosInterceptWixAspects = require('./axios-intercept-wix-aspects');

var _axiosInterceptWixAspects2 = _interopRequireDefault(_axiosInterceptWixAspects);

var _wixHttpClientSupport = require('wix-http-client-support');

var httpClientSupport = _interopRequireWildcard(_wixHttpClientSupport);

var _wixDebug = require('wix-debug');

var _wixDebug2 = _interopRequireDefault(_wixDebug);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _wixDebug2.default)('axios-server-config');

exports.default = function (axios, _ref) {
  var req = _ref.req,
      adapter = _ref.adapter,
      baseURL = _ref.baseURL;

  if (!req) {
    throw new Error('Request must be provided');
  }

  var instance = axios.create({
    baseURL: baseURL || axios.defaults.baseURL,
    adapter: adapter
  });

  instance.unregisterWixInterceptors = _axiosInterceptorsLoader2.default.loadIfNeeded(instance, {
    shouldLoadInterceptors: true,
    interceptors: [(0, _axiosInterceptWixAspects2.default)({ clientSupport: clientSupport(req), logger: log })]
  });

  return instance;
};

function clientSupport(req) {
  return {
    fromResponse: httpClientSupport.fromResponse(req),
    toRequestHeaders: httpClientSupport.toRequestHeaders(req)
  };
}